import './badge.scss';


/**
 * @param {Object} props
 * @param {string} props.text - 뱃지에 표시할 텍스트
 * @param {'solid' | 'soft'} props.type - 뱃지 스타일 (배경 채움 / 연한 배경)
 * @param {'purple' | 'orange' | 'green' | 'yellow' | 'red' | 'blue' | 'black'} props.color - 뱃지 색상
 */
const Badge = ({text, type, color}) => {
  return(
    <div className={`badge-wrapper ${type} ${color}`}>
      <p>{text}</p>
    </div>
  )
}

export default Badge;